<template>
  <no-auth v-if="!hasAuthorize.multipleCycle"></no-auth>
  <ul class="c-list" v-else-if="mini">
    <li class="c-list__item">
      <div class="c-list__item__title">
        <i class="icofont-ui-calculator"></i>
        {{ $t("coolingCapacity.calculate") }}
      </div>
      <SelectBox
        no-label
        :options="filteredOptions"
        v-model="capacity"
        optionField="label"
        :label="$t('coolingCapacity.chooseCapacity')"
        :placeholder="$t('coolingCapacity.chooseCapacity')"
      />
    </li>
  </ul>
  <div v-else class="u-border u-radius-g u-margin-bottom u-padding-xsmall">
    <h6 class="u-margin-0">
      <strong>
        <i
          class="icofont-ui-calculator u-font-size-xsmall u-margin-right-xsmall"
        ></i>
        {{ $t("coolingCapacity.calculate") }}
      </strong>
    </h6>
    <div class="row u-align-items-center u-padding-xsmall">
      <div class="es-xs-12 es-lg-4">
        <Checkbox
          :label="$t('coolingCapacity.withHavaDebili')"
          :value="withHavaDebili"
          :checked="withHavaDebili"
          @change="withHavaDebili = !withHavaDebili"
        />
      </div>
      <div class="es-xs-12 es-lg-8">
        <SelectBox
          no-label
          :options="filteredOptions"
          v-model="capacity"
          optionField="label"
          :label="$t('coolingCapacity.chooseCapacity')"
          :placeholder="$t('coolingCapacity.chooseCapacity')"
        />
        <Button
          :disabled="!capacity"
          block
          variant="light-success"
          @click="exportExcel"
        >
          <i class="icofont-arrow-up"></i> {{ $t("common.export") }}
        </Button>
      </div>
    </div>
    <Modal v-model="showLoadingModal" hide-footer persistent>
      <div class="u-text-align-center">
        <h1 class="u-color-muted">
          <i class="icofont-download"></i>
        </h1>
        <h3 class="u-color-muted u-margin-top-small">
          {{ $t("common.exportingToExcel") }}
        </h3>

        <loading></loading>
      </div>
    </Modal>
  </div>
</template>

<script>
import SelectBox from "@/components/Base/Inputs/SelectBox.vue";
import Button from "@/components/Base/Button.vue";
import Checkbox from "@/components/Base/Inputs/Checkbox.vue";
import { exportCoolingCapacityExcel } from "./CoolingCapacityExcel";
import Modal from "@/components/Base/Modal.vue";
import authorize from "../authorize";
export default {
  mixins: [authorize],
  components: {
    SelectBox,
    Button,
    Checkbox,
    Modal,
  },
  data() {
    return {
      requestIndex: 0,
      showLoadingModal: false,
      results: [],
      withHavaDebili: false,
      capacity: null,
      options: [
        {
          label: "20-55 Condenser air inlet temp",
          condenserAirInletTemp: [20, 25, 30, 35, 40, 45, 50, 55],
          refrigerants: [8, 16, 10, 33, 42], // R134a(8), R407C(16), R227EA(10), R450A(33), R236fa(42)
          evapAirInlet: [
            { temp: 20, humidity: 75 },
            { temp: 22, humidity: 70 },
            { temp: 24, humidity: 60 },
            { temp: 27, humidity: 50 },
            { temp: 30, humidity: 40 },
            { temp: 35, humidity: 30 },
            { temp: 40, humidity: 25 },
          ],
        },
        {
          label: "20-65 Condenser air inlet temp",
          condenserAirInletTemp: [20, 25, 30, 35, 40, 45, 50, 55, 60, 65],
          refrigerants: [8, 10, 33, 42], // R134a(8), R227EA(10), R450A(33), R236fa(42)
          evapAirInlet: [
            { temp: 20, humidity: 75 },
            { temp: 22, humidity: 70 },
            { temp: 24, humidity: 60 },
            { temp: 27, humidity: 50 },
            { temp: 30, humidity: 40 },
            { temp: 35, humidity: 30 },
            { temp: 40, humidity: 25 },
          ],
        },
        {
          label: "20-70 Condenser air inlet temp",
          condenserAirInletTemp: [20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70],
          refrigerants: [10, 33, 42], // R227EA(10), R450A(33), R236fa(42)
          evapAirInlet: [
            { temp: 20, humidity: 75 },
            { temp: 22, humidity: 70 },
            { temp: 24, humidity: 60 },
            { temp: 27, humidity: 50 },
            { temp: 30, humidity: 40 },
            { temp: 35, humidity: 30 },
            { temp: 40, humidity: 25 },
          ],
        },
        {
          label: "20-75 Condenser air inlet temp",
          condenserAirInletTemp: [
            20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75,
          ],
          refrigerants: [10, 33, 42], // R227EA(10), R450A(33), R236fa(42)
          evapAirInlet: [
            { temp: 20, humidity: 75 },
            { temp: 22, humidity: 70 },
            { temp: 24, humidity: 60 },
            { temp: 27, humidity: 50 },
            { temp: 30, humidity: 40 },
            { temp: 35, humidity: 30 },
            { temp: 40, humidity: 25 },
          ],
        },
        {
          label: "20-80 Condenser air inlet temp",
          condenserAirInletTemp: [
            20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80,
          ],
          refrigerants: [10, 42], // R227EA(10), R236fa(42)
          evapAirInlet: [
            { temp: 20, humidity: 75 },
            { temp: 22, humidity: 70 },
            { temp: 24, humidity: 60 },
            { temp: 27, humidity: 50 },
            { temp: 30, humidity: 40 },
            { temp: 35, humidity: 30 },
            { temp: 40, humidity: 25 },
          ],
        },
        {
          label: "20-90 Condenser air inlet temp",
          condenserAirInletTemp: [
            20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
          ],
          refrigerants: [42], // R236fa(42)
          evapAirInlet: [
            { temp: 20, humidity: 75 },
            { temp: 22, humidity: 70 },
            { temp: 24, humidity: 60 },
            { temp: 27, humidity: 50 },
            { temp: 30, humidity: 40 },
            { temp: 35, humidity: 30 },
            { temp: 40, humidity: 25 },
          ],
        },
      ],
    };
  },
  props: {
    refrigerants: {
      type: Number,
      default: 8,
    },
    mini: {
      type: Boolean,
      default: false,
    },
    preventDownload: {
      type: Boolean,
      default: false,
    },
    model: {
      type: String,
      default: "",
    },
  },
  watch: {
    refrigerants() {
      this.capacity = null;
    },
  },
  computed: {
    percentage() {
      const done = this.results.filter((r) => r.status !== "loading").length;
      const total = this.results.length;
      return Math.round((done / total) * 100);
    },
    completedRequest() {
      return this.results.filter((r) => r.status !== "loading").length;
    },
    filteredOptions() {
      const selectedRefrigerant = this.refrigerants;
      const options = this.options.filter((option) =>
        option.refrigerants.includes(selectedRefrigerant)
      );
      if (options.length === 0) {
        return this.options.slice(0, 2);
      }
      return options;
    },
  },
  methods: {
    exportExcel() {
      this.results = [];
      this.capacity.condenserAirInletTemp.forEach(
        (condenserAirInletTemp, index) => {
          this.capacity.evapAirInlet.forEach((evapAirInlet, subIndex) => {
            this.results.push({
              integrationId: `${index}-${subIndex}`,
              condenserAirInletTemp,
              evaporatorAirInletTemp: evapAirInlet.temp,
              evaporatorAirInletHumidity: evapAirInlet.humidity,
              status: "loading",
              data: null,
            });
          });
        }
      );

      this.startExport();
    },
    startExport() {
      this.requestIndex = 0;
      this.$emit("request", this.results, this.callback, this.withHavaDebili);
    },
    request(requestIndex) {
      const data = this.results[requestIndex];
      this.$emit(
        "request",
        data.id,
        {
          condenserAirInletTemp: data.condenserAirInletTemp,
          evaporatorAirInletTemp: data.evaporatorAirInletTemp,
          evaporatorAirInletHumidity: data.evaporatorAirInletHumidity,
        },
        this.callback,
        requestIndex
      );
    },
    callback(data, status, withHavaDebili) {
      this.results.forEach((result) => {
        const item = data.find(
          (item) => item.integrationId === result.integrationId
        );
        if (item) {
          result.data = item;
          result.status = status;
        }
      });
      this.withHavaDebili = withHavaDebili;
      this.setResultForExcel();
      this.showLoadingModal = false;
    },
    checkAllResults() {
      const allResults = this.results.some(
        (result) => result.status === "loading"
      );
      if (!allResults) {
        this.showLoadingModal = false;
        this.setResultForExcel();
        return true;
      }
      return false;
    },
    async setResultForExcel() {
      const excelData = [];
      this.capacity.evapAirInlet.forEach((evapAirInlet) => {
        const data = this.results.filter(
          (result) =>
            result.evaporatorAirInletTemp === evapAirInlet.temp &&
            result.evaporatorAirInletHumidity === evapAirInlet.humidity
        );
        const sortedData = data.sort(
          (a, b) => a.condenserAirInletTemp - b.condenserAirInletTemp
        );
        excelData.push({
          model: this.model,
          evaporatorAirInletTemp: evapAirInlet.temp,
          evaporatorAirInletHumidity: evapAirInlet.humidity,
          withHavaDebili: this.withHavaDebili,
          temps: sortedData.map((item) => {
            const coolingCapacity =
              item.status === "success"
                ? item.data.coolPropCalculateResponse?.cycle_cooling?.toFixed(
                    2
                  ) || 0
                : 0;
            const sensibleCapacity =
              item.status === "success"
                ? item.data.coolPropCalculateResponse?.evap_sensible_capacity?.toFixed(
                    2
                  ) || 0
                : 0;
            const compressorPower =
              item.status === "success"
                ? item.data.compressorResponse?.comp_electrical_power?.toFixed(
                    2
                  ) || 0
                : 0;

            const condFanAirFlow =
              item.status === "success"
                ? item.data?.condFanAirFlow?.toFixed(2) || 0
                : 0;
            return {
              coolingCapacity,
              sensibleCapacity,
              compressorPower,
              condFanAirFlow,
            };
          }),
        });
      });
      const result = await exportCoolingCapacityExcel(
        this.capacity.condenserAirInletTemp,
        excelData,
        this.withHavaDebili,
        this.preventDownload
      );
      this.$emit("export", result);
    },
  },
};
</script>

<style></style>
